import { compose } from 'redux'

import { Tabs } from '@cred/react-tabs'
import { withTabClickEvent, emitOnTabClick } from '@cred/react-analytics/hoc'

const tabsWithAnalytics = compose(withTabClickEvent, emitOnTabClick)(Tabs)

export default tabsWithAnalytics
